import styled from 'styled-components'

import { color } from 'src/styles/colors'
import { fontFamily, fontWeight } from 'src/styles/fonts'

export const Wrap = styled.form`
  position: relative;
  max-width: 35rem;
  width: 100%;
  padding: 0 2rem;
  margin: auto;
`

export const Input = styled.input`
  border-radius: 0.6rem;
  background-color: ${color.WHITE};
  border: none;
  padding-left: 1.6rem;
  font-size: 1.6rem;
  color: ${color.GREYISH_BROWN};
  font-family: ${fontFamily.CATAMARAN};
  padding: 1.2rem;
  width: 100%;
  height: 4.8rem;
  line-height: 4.8rem;

  ::placeholder {
    font-size: 1.6rem;
    color: ${color.PUTTY};
  }
`

export const Button = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 2.5rem;
  bottom: 0.5rem;
  background-color: ${color.PUTTY};
  border-radius: 0.7rem;
  color: ${color.WHITE};
  font-weight: ${fontWeight.BOLD};
  padding: 0 1.6rem;
`
